module.exports = __webpack_public_path__ + "static/google-plus-4d62cac534bc20f0c72fb4113192a79f.jpg";